export default __webpack_public_path__ + "static/media/wave-01.3c9bce1e.png";